import { render, staticRenderFns } from "./FPotensiInfomemo.vue?vue&type=template&id=a0743934&scoped=true"
import script from "./FPotensiInfomemo.vue?vue&type=script&lang=js"
export * from "./FPotensiInfomemo.vue?vue&type=script&lang=js"
import style0 from "./FPotensiInfomemo.vue?vue&type=style&index=0&id=a0743934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0743934",
  null
  
)

export default component.exports